import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, Toolbar, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import Cookies from "js-cookie";
import { useState } from 'react';
import axios from 'axios';

function PackageDetails({ id, teacherButton }) {  
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const { currency } = useSelector(status => status.currency);
  const { conversionRate } = useSelector((state) => state.conversionRate);
  const lang = Cookies.get("i18next") || "en";
  const navigate = useNavigate();

  const image = data?.image ? `${process.env.REACT_APP_API_KEY}images/${data.image}` : "/logo.png";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_KEY}api/v1/packages/get-package/${id}`);
        console.log(res.data);
        
        setData(res.data);
      } catch (error) {
        console.error("Error fetching package data", error);
      }
    };
    fetchData();
  }, [id]);

  const handleClose = () => setOpen(false);
  const convertDate = (dateString) => new Date(dateString).toISOString().split('T')[0];
  if (!data) return <div>{t("loading")}...</div>;
  return <React.Fragment>
    <Button variant="contained" size='small' sx={{height:"50px"}} onClick={() => setOpen(true)}>{t("details")}</Button>
    <Dialog
      open={open}
      TransitionComponent={Transition}
      fullScreen
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">{t("package")}</Typography>
          <Button autoFocus color="inherit" onClick={handleClose}>{t("close")}</Button>
        </Toolbar>
      </AppBar>
      <DialogTitle>
        <div className='flex justify-center mt-5'>
          <img className='object-fill h-48 w-96 shadow' src={image} alt="package img" />
        </div>
        <h1 className='text-center text-xl mt-4'>
        {lang==="ar" ? 
            <>
              {`${t("package")}: ${data?.titleAr}`}
            </> : 
            <>
            {`${t("package")}: ${data?.titleEn}`}
            </>
            }
        </h1>
      </DialogTitle>
      <DialogContent>
        <p className='sm:truncate mb-8 text-lg'>
        {lang==="ar" ? 
            <>
          {t("description")}: {data?.descriptionAr}
            </> : 
            <>
          {t("description")}: {data?.descriptionEn}
            </>
            }
        </p>
        <div className="grid  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <Typography variant="h6">
            {lang==="ar" ? 
            <>
              {`${t("level")}: ${data?.level.titleAR}`}
            </> : 
            <>
            {`${t("level")}: ${data?.level.titleEN}`}
            </>
            }
          </Typography>
          <Typography variant="h6">
            {lang==="ar" ? 
            <>
              {`${t("classes")}: ${data?.classId?.titleAR}`}
            </> : 
            <>
            {`${t("classes")}: ${data?.classId?.titleEN}`}
            </>
            }
          </Typography>
          <Typography variant="h6">
                   {`${t("semester")}: ${t(data?.semester)}`}

          </Typography>
          <Typography variant="h6">
            {lang==="ar" ? 
            <>
              {`${t("studyCurriculum")}: ${data?.curriculums?.titleAR}`}
            </> : 
            <>
            {`${t("studyCurriculum")}: ${data?.curriculums?.titleEN}`}
            </>
            }
          </Typography>
          {data?.docs?<Typography variant="h6">
            {`${t("Package documents")}:`} <Button
            variant="contained"

                                          component={Link}
                                          to={`${process.env.REACT_APP_API_KEY}images/${data?.docs}`}
                                          target="_blank" // يفتح الرابط في صفحة جديدة
                                          rel="noopener noreferrer"
                                        >
                                          {t("Package documents")}
                                        </Button>
          </Typography>:" "}
          {data?.linkPackage?<Typography variant="h6">
            {`${t("Link Package")}:`} <Button
            variant="contained"
                                          component={Link}
                                          to={data?.linkPackage}
                                          target="_blank" // يفتح الرابط في صفحة جديدة
                                          rel="noopener noreferrer"
                                        >
                                          {t("Link Package")}
                                        </Button>
          </Typography>:" "}
          
          <Typography variant="h6">
            {`${t("sharesCount")}: ${data?.numberOfShares} ${t("shares")}`}
          </Typography>
          <Typography variant="h6">
            {`${t("sharesCountInWeek")}: ${data?.sharesInWeek} ${t("shares")}`}
          </Typography>
          <Typography variant="h6">
            {`${t("sharePrice")}: ${(data?.price * conversionRate).toFixed(2)}`}
          </Typography>
          <Typography variant="h6">
            {`${t("sharesTotal")}: ${(data?.price * data?.numberOfShares * conversionRate).toFixed(2)}`}
          </Typography>
          <Typography variant="h6">
            {`${t("currency")}: ${t(currency)}`}
          </Typography>
          <Typography gutterBottom variant="h6">
            {`${t("duration")}:`} {`${data?.duration} ${t("hour")}`}
          </Typography>
          <Typography variant="h6">
            {t("startDate")}: {convertDate(data?.startDate)}
          </Typography>
          <Typography variant="h6">
            {t("endDate")}: {convertDate(data?.endDate)}
          </Typography>
          <Typography variant="h6">
            {t("packagePlace")}: {t(`${data?.packageType}_place`)}
          </Typography>
          <Typography variant="h6">
            {t("registryDate")}: {data?.createdAt.split("T")[0]}
          </Typography>
        </div>
      </DialogContent>
      {
        teacherButton ? <DialogActions sx={{ margin: "auto" }}>
          <Button variant='contained' sx={{ width: "400px" }} onClick={() => navigate("/teacher/" + data?.teacherId)}>{t("teacher")}</Button>
        </DialogActions> : ""
      }

    </Dialog>
  </React.Fragment>
}

export default PackageDetails;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});